const deutsch = {
    'STAFF_MANAGEMENT.SummaryBooked': "Gebucht",
    'STAFF_MANAGEMENT.SummaryHelpIncludedGroups': "Berücksichtigte Benutzergruppen: { groups }.",
    'STAFF_MANAGEMENT.SummaryHelpGroupsLoading': "Gruppennamen werden geladen…",
    'STAFF_MANAGEMENT.SummaryHelpGroupsUnavailable': "Die Gruppennamen sind derzeit nicht verfügbar.",
    'STAFF_MANAGEMENT.SummaryHelpBookedTitle': "Informationen zu Gebucht",
    'STAFF_MANAGEMENT.SummaryHelpCheckedInTitle': "Informationen zu Eingecheckt",
    'STAFF_MANAGEMENT.SummaryHelpClose': "Schließen",
    'STAFF_MANAGEMENT.SummaryHelpBooked': "Anzahl der für diese Veranstaltung bei Subunternehmern gebuchten Mitarbeiter. Sie kann von der Personenzahl in der Liste „Anwesende Mitarbeiter“ abweichen.",
    'STAFF_MANAGEMENT.SummaryHelpBookedAttendance': "Die ausgewählte Firma wird berücksichtigt. „Alle Firmen“ zeigt die gesamte Buchung. Das ausgewählte Datum ändert die gebuchte Anzahl nicht.",
    'STAFF_MANAGEMENT.SummaryHelpCheckedIn': "Anzahl der berücksichtigten Mitarbeiter mit offenem Check-in, einschließlich Sitzungen, die an früheren Tagen begonnen wurden. Die gezählten Mitarbeiter können von der Liste „Anwesende Mitarbeiter“ abweichen. Die Zahl in Klammern ist die Differenz zu „Gebucht“.",
    'STAFF_MANAGEMENT.SummaryHelpCheckedInAttendance': "Die Karten zeigen den Status für den ausgewählten Tag. Ein Mitarbeiter mit einer offenen Sitzung von einem früheren Tag kann daher unter „Eingecheckt“ mitgezählt werden, obwohl für heute „Nicht eingecheckt“ angezeigt wird.",
    'STAFF_MANAGEMENT.SummaryBookedForExhibition': "gebucht für Veranstaltung",
    'STAFF_MANAGEMENT.SummaryUnavailable': "Nicht verfügbar",
    'STAFF_MANAGEMENT.SummaryError': "Die Mitarbeiterzahlen konnten nicht geladen werden.",
    'STAFF_MANAGEMENT.Title_Point': "Check-in-Point setzen",
    'STAFF_MANAGEMENT.Title_Attendance': "Anwesende Mitarbeiter",
    'STAFF_MANAGEMENT.UseLocation': "Meinen Standort verwenden",
    'STAFF_MANAGEMENT.SetPoint': "Check-in-Punkt festlegen",
    'STAFF_MANAGEMENT.SetPointHelp': "Stellen Sie sich dorthin, wo die Mitarbeiter einchecken, und speichern Sie Ihren Standort.",
    'STAFF_MANAGEMENT.CheckPin': "Prüfen Sie, ob dies der richtige Ort ist",
    'STAFF_MANAGEMENT.CheckSpot': "Markierung prüfen und speichern",
    'STAFF_MANAGEMENT.Retake': "Neu ermitteln",
    'STAFF_MANAGEMENT.Save': "Speichern",
    'STAFF_MANAGEMENT.Saving': "Speichern…",
    'STAFF_MANAGEMENT.Locating': "Ihr Standort wird genauer ermittelt. Bleiben Sie am Check-in-Punkt — dies kann bis zu 15 Sekunden dauern.",
    'STAFF_MANAGEMENT.LocationAccuracy': "Geschätzte Genauigkeit: { accuracy } m",
    'STAFF_MANAGEMENT.LowAccuracyTitle': "Geringe Standortgenauigkeit",
    'STAFF_MANAGEMENT.LowAccuracyHelp': "Prüfen Sie die Markierung und verschieben Sie sie bei Bedarf.",
    'STAFF_MANAGEMENT.LocationPermission': "Erlauben Sie den Standortzugriff in Ihren Browsereinstellungen und versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.LocationTimeout': "Ihr Standort konnte nicht rechtzeitig ermittelt werden. Bleiben Sie am Check-in-Punkt und versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.LocationUnavailable': "Ihr Standort ist nicht verfügbar. Prüfen Sie die Standorteinstellungen Ihres Geräts und versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.MapUnavailable': "Die Karte konnte nicht geladen werden. Versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.Ready': "Bereit für den Check-in",
    'STAFF_MANAGEMENT.UpdateLocation': "Standort aktualisieren",
    'STAFF_MANAGEMENT.ViewQr': "QR-Code anzeigen",
    'STAFF_MANAGEMENT.PointCreated': "Check-in-Punkt festgelegt",
    'STAFF_MANAGEMENT.PointUpdated': "Check-in-Punkt aktualisiert",
    'STAFF_MANAGEMENT.SaveError': "Das Speichern konnte nicht bestätigt werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.NoManageAccess': "Sie haben keine Berechtigung, diesen Check-in-Punkt festzulegen oder zu ändern.",
    'STAFF_MANAGEMENT.NoAttendanceAccess': "Sie haben keine Berechtigung, die Anwesenheit der Mitarbeiter einzusehen.",
    'STAFF_MANAGEMENT.SelectExhibition': "Wählen Sie zuerst eine Veranstaltung aus.",
    'STAFF_MANAGEMENT.Loading': "Wird geladen…",
    'STAFF_MANAGEMENT.Retry': "Erneut versuchen",
    'STAFF_MANAGEMENT.Back': "Zurück",
    'STAFF_MANAGEMENT.QrTitle': "Check-in-QR-Code",
    'STAFF_MANAGEMENT.QrMissing': "Es ist noch kein Check-in-QR-Code verfügbar.",
    'STAFF_MANAGEMENT.QrError': "Der QR-Code konnte nicht geladen werden. Versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.GenerateQr': "QR-Code erstellen",
    'STAFF_MANAGEMENT.GeneratingQr': "QR-Code wird erstellt…",
    'STAFF_MANAGEMENT.QrGenerateError': "Der Punkt ist gespeichert, aber der QR-Code konnte nicht erstellt werden. Versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.DownloadPdf': "PDF herunterladen",
    'STAFF_MANAGEMENT.PdfLoading': "PDF wird erstellt…",
    'STAFF_MANAGEMENT.PdfError': "Das PDF konnte nicht erstellt werden. Versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.Today': "Heute",
    'STAFF_MANAGEMENT.ChooseDate': "Datum auswählen",
    'STAFF_MANAGEMENT.ChooseCompany': "Firma auswählen",
    'STAFF_MANAGEMENT.AllCompanies': "Alle Firmen",
    'STAFF_MANAGEMENT.Apply': "Anwenden",
    'STAFF_MANAGEMENT.NoCheckIn': "Nicht eingecheckt",
    'STAFF_MANAGEMENT.In': "Ein",
    'STAFF_MANAGEMENT.Out': "Aus",
    'STAFF_MANAGEMENT.Working': "Bei der Arbeit",
    'STAFF_MANAGEMENT.Completed': "Abgeschlossen",
    'STAFF_MANAGEMENT.FailedCheckout': "Check-out fehlgeschlagen",
    'STAFF_MANAGEMENT.MissedCheckout': "Check-out fehlt",
    'STAFF_MANAGEMENT.UnknownStatus': "Unbekannter Status",
    'STAFF_MANAGEMENT.NoAttendanceRecords': "Keine Anwesenheitseinträge für dieses Datum.",
    'STAFF_MANAGEMENT.NoMatches': "Für die gewählten Filter wurden keine Mitarbeiter gefunden.",
    'STAFF_MANAGEMENT.AttendanceError': "Die Anwesenheit konnte nicht geladen werden. Versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.UnknownCompany': "Firma nicht angegeben",
    'STAFF_MANAGEMENT.LoadPointError': "Der Check-in-Punkt konnte nicht geladen werden. Versuchen Sie es erneut.",
    'STAFF_MANAGEMENT.PosterTitle': "Check-in / Check-out",
    'STAFF_MANAGEMENT.PosterInstructions': "Öffnen Sie die ELFE-App und scannen Sie diesen QR-Code zu Beginn und am Ende Ihrer Arbeit.",
    'STAFF_MANAGEMENT.PosterGenerated': "QR-Code erstellt: { date }",
    'PHOTO_SOURCE.TakePhoto' : 'Foto aufnehmen',
    'PHOTO_SOURCE.ChooseFromGallery' : 'Aus Galerie auswählen',
    'CRAFT.Type_Logistics' : 'Logistik { number }',
    'CRAFT.Type_Floor' : 'Boden { number }',
    'CRAFT.Type_Assembly' : 'Montage { number }',
    'CRAFT.Type_Electrics' : 'Elektrik { number }',
    'CRAFT.Type_Graphic' : 'Grafik { number } ',
    'CRAFT.Type_Furniture' : 'Möbel { number }',
    'CRAFT.Type_Multimedia' : 'Multimedia { number }',
    'CRAFT.Type_Cleaning' : 'Reinigung { number }',
    'CRAFT.Type_Additional' : 'Sonstiges { number }',
    'CRAFT.Type_MPControl' : 'MP Kontrolle',
    'CRAFT.Type_Protocol' : 'Protokoll',
    'CRAFT.Type_Service' : 'Service { number }',
    'CRAFT.Type_CollectGraphics' : 'Grafik einlagern',
    'CRAFT.Status_Text_InProgress' : 'In Bearbeitung',
    'CRAFT.Status_Text_Disabled' : 'Gesperrt',
    'CRAFT.Status_Text_Completed' : 'Fertiggestellt',
    'CRAFT.Status_Text_Overdue' : 'Überfällig',
    'CRAFT.Status_Text_Done' : 'Grafik demontiert',
    'CRAFT.Status_Text_Open' : 'noch offen',
    'CRAFT.Status_Text_Collected' : 'Grafik demontiert',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Status kann nicht geändert werden: die Grafik wurde bereits im Admin-Panel bearbeitet',
    'CRAFT.Button_Text_MarkDone' : 'Fertiggestellt',
    'CRAFT.Button_Text_MarkInProgress' : 'In Bearbeitung',
    'CRAFT.Button_Text_MarkOpen' : 'Als offen markieren',
    'CRAFT.Button_ViewAll' : 'Alle anzeigen',
    'CRAFT.Button_Text_Print' : 'Drucken',
    'CRAFT.Button_Text_Stand' : 'Stand',
    'CRAFT.Button_ChangeStatus_InProgress' : 'In Bearbeitung',
    'CRAFT.Button_ChangeStatus_Done': 'Fertig',
    'CRAFT.Button_Text_ShelfNumber' : 'Regal Nr.',
    'CRAFT.Filter_Params_CraftType' : 'Gewerk: { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Bitte eine Veranstaltung aus { br } folgender Liste wählen',
    'EXHIBITION.Select_Label' : 'Gewählte Veranstaltung',
    'EXHIBITION.Modal_Title' : 'Wähle eine Veranstaltung',
    'EXHIBITION.Timer_State_Underway' : 'Gestartet',
    'EXHIBITION.Timer_State_Ended' : 'Beendet',
    'EXHIBITION.Title_CraftTotal' : 'Gesamtübersicht Gewerke',
    'EXHIBITION.Statistic_Status_InTotal' : 'Insgesamt',
    'EXHIBITION.Statistic_Status_InProgress' : 'In Bearbeitung',
    'EXHIBITION.Statistic_Status_Done' : 'Fertig',
    'EXHIBITION.Statistic_Status_Overdue' : 'Überfällig',
    'EXHIBITION.Statistic_Status_NotApproved' : 'Nicht freigegeben',
    'EXHIBITION.Statistic_Status_BookedForExhibition' : 'gebucht für Veranstaltung',
    'EXHIBITION.Statistic_Status_CheckedIn' : 'Eingecheckt',
    'EXHIBITION.Statistic_Type_Stands' : 'Stände',
    'EXHIBITION.Statistic_Type_Claims' : 'mp Reklamationen',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Aussteller Reklamation',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Last Minute',
    'EXHIBITION.Statistic_Type_MpControl' : 'MP Kontrolle',
    'EXHIBITION.Statistic_Type_Damages' : 'Schäden',
    'EXHIBITION.Statistic_Type_Protocol' : 'Protokoll',
    'EXHIBITION.Statistic_Type_Staff' : 'Mitarbeiter',
    'FORM.Textarea_Placeholder_JobDescription' : 'Job-Beschreibung*',
    'FORM.Button_Text_AddJob' : 'Job hinzufügen',
    'FORM.Button_Text_SaveJob' : 'Job speichern ',
    'FORM.Button_AddJobPhoto' : 'Foto hinzufügen',
    'FORM_RULES.Required_Login' : 'Bitte Login eingeben',
    'FORM_RULES.Required_Password' : 'Bitte Passwort eingeben',
    'FORM_RULES.Required_KeyDescription' : 'Bitte Schlüsselbeschreibung eingeben',
    'FORM_RULES.Required_KeyNumber' : 'Bitte Schlüsselnummer eingeben',
    'FORM_RULES.Required_JobDescription' : 'Bitte Jobbeschreibung hinzufügen',
    'FORM_RULES.Required_Quantity' : 'Bitte Menge eingeben',
    'FORM_RULES.Min_Quantity' : 'Die Menge muss eine Zahl sein, die nicht kleiner als eins ist',
    'FORMS.Input_Label_Login' : 'Anmelden',
    'FORMS.Input_Label_Password' : 'Passwort',
    'FORMS.Button_Text_Login' : 'Login',
    'FORMS.Input_Label_Description' : 'Beschreibung',
    'FORMS.Input_Label_KeyNumber' : 'Schlüsselnummer',
    'FORMS.Input_Label_Hall' : 'Halle',
    'FORMS.Input_Label_Stands' : 'Stände',
    'FORMS.Button_Text_ApplyFilters' : 'Anwenden',
    'FORMS.Button_Text_ResetFilters' : 'Filter zurücksetzen',
    'FORMS.Select_DefaultValue_All' : 'Alles',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'mit Gewerk in Bearbeitung',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'mit abgeschlossenem Gewerk',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'mit Gewerk Kontrolle in Bearbeitung',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'mit Gewerk Protokoll in Bearbeitung',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'mit überfälligen Gewerken',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'mit zusätzlichen Jobs',
    'FORMS.Button_Text_ApplySort' : 'Anwenden',
    'FORMS.Input_Label_CraftType' : 'Gewerketyp',
    'FORMS.Input_Label_JobType' : 'Typ',
    'FORMS.Input_Label_JobFlag' : 'Flagge',
    'FORMS.Input_Label_JobStatus' : 'Status',
    'FORMS.Input_Label_CraftStatus' : 'Gewerkestatus',
    'FORMS.Input_Label_DamageStatus' : 'Schadenstatus',
    'FORMS.Input_Label_Subcontractor' : 'Subunternehmer',
    'FORMS.Input_Label_Comments' : 'Kommentare',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Offen Jobs',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Jobs in Bearbeitung',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Abgeschlossene Jobs',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Ohne Flagge',
    'FORMS.Select_JobFlag_WithFlag' : 'Mit Fahne',
    'FORMS.RadioInput_Text_Description' : 'Beschreibung',
    'FORMS.RadioInput_Text_Furnishing' : 'Ausstattung hinzufügen',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Ausstattungs Reklamation',
    'FORMS.Input_Label_FurnishingName' : 'Ausstattungs Artikel',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Rücknahme Menge',
    'FORMS.Input_Label_Quantity' : 'Menge',
    'FORMS.Input_Label_CurrentQuantity' : 'Bestand aktuell',
    'FORMS.Input_Label_NewQuantity' : 'Bestand neu',
    'FORMS.Input_Label_OrderType'   : 'Änderungstyp',
    'FORMS.Select_FurnishingOrder_Type_Return' : "Artikel Rücknahme",
    'FORMS.Select_FurnishingOrder_Type_Lost' : "Verloren",
    'FORMS.Select_FurnishingOrder_Type_Correction' : "Gesamtmenge ändern",
    'FORMS.Select_FurnishingOrder_Type_Order' : "Befehl",
    'GLOBAL.Text_Piece' : 'st.',
    'GLOBAL.Button_Text_Logout' : 'Logout',
    'GLOBAL.Button_Text_Filter' : 'Filter',
    'GLOBAL.Button_Text_Sort' : 'Sortieren',
    'GLOBAL.Text_Version' : 'Version { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Abbrechen',
    'ATTENDANCE.Button_CheckIn': 'Check-In',
    'ATTENDANCE.Button_CheckOut': 'Check-Out',
    'ATTENDANCE.SelectExhibitionFirst_Text': 'Bitte zuerst eine Veranstaltung auswaehlen.',
    'ATTENDANCE.Button_RetryScan': 'Erneut scannen',
    'ATTENDANCE.Button_Close': 'Schliessen',
    'ATTENDANCE.Modal_Title_CheckIn': 'Check-In scannen',
    'ATTENDANCE.Modal_Title_CheckOut': 'Check-Out scannen',
    'ATTENDANCE.Scanner_Hint': 'Kamera auf den QR-Code richten',
    'ATTENDANCE.Processing_Locating_Title': 'Standort wird genauer bestimmt…',
    'ATTENDANCE.Processing_Locating_Text': 'Bitte bleiben Sie stehen. Dies kann bis zu 15 Sekunden dauern.',
    'ATTENDANCE.Processing_Submitting_Title': 'Scan wird gesendet...',
    'ATTENDANCE.Processing_Submitting_Text': 'Bitte warten. Die Arbeitszeit wird gespeichert.',
    'ATTENDANCE.Error_GpsPermission_Title': 'Standortzugriff erforderlich',
    'ATTENDANCE.Error_GpsPermission_Text': 'Bitte Standortzugriff im Browser erlauben und erneut versuchen.',
    'ATTENDANCE.Error_GpsTimeout_Title': 'Schwaches GPS-Signal',
    'ATTENDANCE.Error_GpsTimeout_Text': 'Es konnten keine Koordinaten gefunden werden. Gehen Sie naeher zum Ausgang und scannen Sie erneut.',
    'ATTENDANCE.Error_GpsUnavailable_Title': 'GPS nicht verfuegbar',
    'ATTENDANCE.Error_GpsUnavailable_Text': 'Standortdaten sind auf diesem Geraet nicht verfuegbar.',
    'ATTENDANCE.Error_Camera_Title': 'Kamera nicht verfuegbar',
    'ATTENDANCE.Error_Camera_Text': 'Bitte Kamerazugriff erlauben und erneut versuchen.',
    'ATTENDANCE.Error_CameraPermission_Title': 'Kamerazugriff blockiert',
    'ATTENDANCE.Error_CameraPermission_Text': 'Bitte Kamerazugriff in den Website-Einstellungen des Browsers erlauben und erneut versuchen.',
    'ATTENDANCE.Error_CameraNotFound_Title': 'Keine Kamera gefunden',
    'ATTENDANCE.Error_CameraNotFound_Text': 'Dieses Geraet stellt dem Browser keine verfuegbare Kamera bereit.',
    'ATTENDANCE.Error_SecureContext_Title': 'HTTPS erforderlich',
    'ATTENDANCE.Error_SecureContext_Text': 'Kamera und GPS funktionieren im mobilen Browser nur ueber HTTPS. App ueber einen HTTPS-dev tunnel oeffnen.',
    'ATTENDANCE.Error_Server_Title': 'Scan fehlgeschlagen',
    'ATTENDANCE.Error_Server_Text': 'Der Server konnte den Scan nicht verarbeiten. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    'ATTENDANCE.Error_Generic_Title': 'Scan fehlgeschlagen',
    'ATTENDANCE.Error_Generic_Text': 'Bitte erneut versuchen.',
    'ATTENDANCE.Result_CheckInAccepted_Title': 'Check-In erfolgreich',
    'ATTENDANCE.Result_CheckOutAccepted_Title': 'Check-Out erfolgreich',
    'ATTENDANCE.Result_Accepted_Text': 'Zeit: { serverTime }. Sie sind im System erfasst.',
    'ATTENDANCE.Result_Duplicate_Title': 'Bereits erfasst',
    'ATTENDANCE.Result_Duplicate_Text': 'Dieser Scan wurde bereits gespeichert.',
    'ATTENDANCE.Result_OpenSessionElsewhere_Title': 'Bei einer anderen Veranstaltung eingecheckt',
    'ATTENDANCE.Result_OpenSessionElsewhere_Text': 'Checken Sie dort aus, bevor Sie hier einchecken. Falls Sie keinen Zugriff auf diese Veranstaltung haben, wenden Sie sich an Ihre Bau- oder Projektleitung.',
    'ATTENDANCE.Result_ShiftClosed_Title': 'Schicht bereits geschlossen',
    'ATTENDANCE.Link_MyTimeRecords': 'Meine Zeiteinträge ansehen',
    'ATTENDANCE.Result_ShiftClosed_Text': 'Ihre Schicht ist bereits geschlossen. Wenn Sie nicht selbst ausgecheckt haben, hat möglicherweise eine Führungskraft Ihre Schicht geschlossen. Checken Sie ein, um eine neue Schicht zu beginnen.',
    'ATTENDANCE.Result_AlreadyCheckedIn_Title': 'Bereits eingecheckt',
    'ATTENDANCE.Result_AlreadyCheckedIn_Text': 'Checken Sie bei dieser Veranstaltung aus, bevor Sie erneut einchecken.',
    'ATTENDANCE.Result_Rejected_Title': 'Zugang abgelehnt',
    'ATTENDANCE.Result_OutsideRadius_Text': 'Sie sind zu weit vom Eingang entfernt. Bitte gehen Sie naeher zum Eingang.',
    'ATTENDANCE.Result_InvalidQr_Text': 'Dieser QR-Code ist fuer Check-In/Out nicht gueltig.',
    'ATTENDANCE.Result_GenericRejected_Text': 'Der Scan wurde abgelehnt.',
    'ATTENDANCE.Button_Back': 'Zurück',
    'ATTENDANCE.Button_TryAgain': 'Erneut versuchen',
    'ATTENDANCE.Button_GotIt': 'OK Verstanden',
    'ATTENDANCE.Overview_NotCheckedIn': 'Nicht eingecheckt',
    'ATTENDANCE.Overview_CheckInPrompt': 'Per QR-Code{ br }einchecken',
    'ATTENDANCE.Overview_CheckedIn_Label': 'Sie sind eingecheckt',
    'ATTENDANCE.Overview_CheckedInAt': 'um { time } Uhr',
    'ATTENDANCE.Scanner_CheckIn_Hint': 'Vor Arbeitsbeginn den QR-Code zum Einchecken scannen',
    'ATTENDANCE.Scanner_CheckOut_Hint': 'Zum Auschecken den QR-Code auf der Veranstaltung scannen',
    'ATTENDANCE.Error_StatusLoad_Text': 'Der Check-in-Status konnte nicht geladen werden.',
    'ATTENDANCE.Error_CameraDesign_Title': 'Die App kann Ihre Kamera nicht öffnen',
    'ATTENDANCE.Error_CameraDesign_Text': 'Zum Einchecken müssen Sie den Code mit Ihrer Handykamera scannen. Tippen Sie auf Erneut versuchen und erlauben Sie den Kamerazugriff.',
    'ATTENDANCE.Error_Camera_Settings_Hint': 'Funktioniert es noch nicht? Prüfen Sie die Kameraberechtigung in den Browser-Einstellungen.',
    'ATTENDANCE.Error_LocationDesign_Title': 'Die App kann Ihren Standort nicht ermitteln',
    'ATTENDANCE.Error_LocationDesign_Text': 'Für den Check-in wird Ihr Standort benötigt. Aktivieren Sie ihn in den Einstellungen und tippen Sie auf Erneut versuchen.',
    'ATTENDANCE.Result_CheckedInAt': 'Sie haben sich am { date }. um { time } eingecheckt',
    'ATTENDANCE.Result_CheckInSuccessAt': 'Sie haben sich erfolgreich um { time } zur Arbeit eingecheckt.',
    'ATTENDANCE.Result_CheckedOutAt': 'Sie haben um { time } Ihre Arbeit beendet{ br }und ausgechecked',
    'ATTENDANCE.Result_OutsideRadius_Title': 'Sie müssen am Veranstaltungsort sein',
    'ATTENDANCE.Result_OutsideRadius_DesignText': 'Ihr Standort stimmt nicht mit der Veranstaltung überein. Check-ins werden per GPS erfasst. Versuchen Sie es am richtigen Ort erneut.',
    'ATTENDANCE.Result_LowAccuracy_Title': 'Geringe Standortgenauigkeit',
    'ATTENDANCE.Result_LowAccuracy_Badge': 'Genauigkeit: { accuracy } (Zu gering)',
    'ATTENDANCE.Result_LowAccuracy_CheckIn': 'Zum Einchecken bitte:',
    'ATTENDANCE.Result_LowAccuracy_CheckOut': 'Zum Auschecken bitte:',
    'ATTENDANCE.Result_LowAccuracy_PreciseLocation': 'Aktivieren Sie „Genauer Standort“ für Ihren Browser in den Telefoneinstellungen',
    'ATTENDANCE.Result_LowAccuracy_Wifi': 'Schalten Sie WLAN ein, um die Standortbestimmung zu unterstützen',
    'ATTENDANCE.Result_LowAccuracy_Retry': 'Tippen Sie dann auf { back } und scannen Sie den Code erneut.',
    'ATTENDANCE.Accuracy_Meters': '{ value } m',
    'ATTENDANCE.Accuracy_Kilometers': '{ value } km',
    'ATTENDANCE.Result_InvalidQr_Title': 'Das ist nicht der richtige Code',
    'ATTENDANCE.Result_InvalidQr_CheckIn_Title': 'Check-in nicht möglich!',
    'ATTENDANCE.Result_InvalidQr_CheckOut_Title': 'Check-out nicht möglich!',
    'ATTENDANCE.Result_InvalidQr_DesignText': 'Dieser QR-Code gehört nicht zu Ihrer Veranstaltung. Bitte wenden Sie sich an Ihre Bau- oder Projektleitung.',
    'ATTENDANCE.Result_OutdatedQr_Text': 'Es existiert eine neuer Version von diesem QR Code - bitte nutzen Sie diesen zum Anmelden.',
    'ATTENDANCE.Result_DeviceConflict_Title': 'Check-in nicht möglich!',
    'ATTENDANCE.Result_DeviceConflict_Text': 'Mit diesem Handy ist bereits eine andere Person eingecheckt wurden. Die App erlaubt es nicht, das 2 verschiede Anwender sich mit dem gleichen Gerät eichecken!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Title': 'Check-in-Scan nicht möglich!',
    'ATTENDANCE.Result_OutsideSchedule_CheckIn_Text': 'Der Check-in ist nur während des festgelegten Veranstaltungszeitraums möglich. Bitte wenden Sie sich an Ihre Bau- oder Projektleitung.',
    'ATTENDANCE.Result_OutsideSchedule_CheckOut_Title': 'Check-out ist derzeit nicht verfügbar',
    'ATTENDANCE.Result_OutsideSchedule_Text': 'Diese Aktion ist nur im konfigurierten Veranstaltungszeitraum verfügbar. Prüfen Sie die ausgewählte Veranstaltung und ihre Daten.',
    'ATTENDANCE.TimeRecords_CheckIn': 'Kommen:',
    'ATTENDANCE.TimeRecords_CheckOut': 'Gehen:',
    'ATTENDANCE.TimeRecords_InProgress': 'läuft',
    'ATTENDANCE.TimeRecords_Missed': 'fehlt',
    'ATTENDANCE.TimeRecords_Empty': 'Noch keine Zeiteinträge.',
    'ATTENDANCE.Error_TimeRecordsLoad_Text': 'Die Zeiteinträge konnten nicht geladen werden.',
    'MENUS.Label_MyTimeRecords': 'Meine Zeiten',
    'PAGE.Title_MyTimeRecords': 'Meine Zeiten',
    'GLOBAL.Badge_Text_New' : 'NEU',
    'GLOBAL.Modal_Title_Filters' : 'Filter',
    'GLOBAL.Modal_Title_SortBy' : 'Sortieren nach',
    'GLOBAL.TimeLeft' : 'noch { timeLeft }',
    'GLOBAL.Button_Text_Confirm': 'Ändern',
    'GLOBAL.Language_Default' : 'Standard',
    'TRANSLATION.Button_Text_Translate' : 'Uebersetzen',
    'TRANSLATION.Button_Text_TranslateInput' : 'Nach Deutsch uebersetzen',
    'TRANSLATION.Button_Text_TranslateEnglish' : 'Nach Englisch uebersetzen',
    'TRANSLATION.Button_Text_TranslateNative' : 'In meine Sprache uebersetzen',
    'TRANSLATION.Button_Text_ShowOriginal' : 'Deutsches Original anzeigen',
    'TRANSLATION.Text_InputTranslating' : 'Wird uebersetzt...',
    'TRANSLATION.Text_InputTranslated' : 'Uebersetzt',
    'TRANSLATION.Text_InputTranslationError' : 'Uebersetzung fehlgeschlagen',
    'TRANSLATION.Text_InputTranslationRequired' : 'Bitte Text vor dem Senden uebersetzen',
    'TRANSLATION.Text_ApiUnavailable' : 'Uebersetzung ist derzeit nicht moeglich',
    'GLOBAL.Card_Hero_Hall' : 'Halle',
    'GLOBAL.Card_Hero_Block' : 'Block',
    'GLOBAL.Card_Hero_Stand' : 'Stand',
    'GLOBAL.Comment': 'Kommentar',
    'HALL.Button_Text_HallPlan' : 'Hallenplan',
    'HALL.Link_Text_HallPlan' : '{ hallName } Hallenplan',
    'JOB.Tag_Claim' : 'R',
    'JOB.Tag_CustomerClaim' : 'R',
    'JOB.Tag_MPAndCustomerClaim' : 'R',
    'JOB.Tag_LastMinute' : 'L',
    'JOB.Tag_Damage' : 'S',
    'JOB.Tag_ProtocolDefect' : 'M',
    'JOB.Card_Hero_Hall' : 'Halle',
    'JOB.Card_Hero_Number' : 'Job Nr.',
    'JOB.Card_Hero_Block' : 'Block',
    'JOB.Card_Hero_Stand' : 'Stand',
    'JOB.Card_Hero_Exhibitor' : 'Aussteller',
    'JOB.Button_Text_ToTheStand' : 'Zum Stand',
    'JOB.Text_Creator' : 'Erstellt von { whoCreate } am { whenCreate }',
    'JOB.Text_Executor' : 'Bearbeitet von { whoExecute } am { whenExecute }',
    'JOB.Text_DurationTime' : 'Dauer: { time }',
    'JOB.Text_InWork' : 'von { whoWork } am { whenWork }',
    'JOB.Type_Claim' : 'mp Reklamation',
    'JOB.Type_AllClaims' : 'Reklamation',
    'JOB.Type_CustomerClaim' : 'Aussteller Reklamation',
    'JOB.Type_LastMinute' : 'Last Minute',
    'JOB.Type_Damage' : 'Schaden',
    'JOB.Type_ProtocolDefect' : 'Mangel',
    'JOB.Button_ChangeStatus_Waiting' : 'Job Annehmen',
    'JOB.Button_ChangeStatus_InProgress' : 'Job In Bearbeitung',
    'JOB.Button_ChangeStatus_Done' : 'Job Fertig',
    'JOB.Modal_Title_Photo' : 'Job Foto',
    'JOB.Filter_Params_JobType' : 'Typ: { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Gewerk: { withFilter }',
    'JOB.Modal_Title_NewJob' : 'Neu { jobType }',
    'JOB.Modal_Title_EditJob' : 'Bearbeiten { jobType }',
    'JOB.Button_Text_AddClaim' : 'mp Reklamationsjob hinzufügen',
    'JOB.Button_Text_AddCustomerClaim' : 'Aussteller Reklamation job hinzufügen',
    'JOB.Button_Text_AddLastMinute' : 'Last Minute Job hinzufügen',
    'JOB.Button_Text_AddDamage' : 'Schaden erfassen',
    'JOB.Button_Text_AddProtocolDefect' : 'Mangel hinzufügen',
    'DAMAGE.Card_Title' : 'Schäden der { exhibitor }',
    'DAMAGE.Modal_Title_Photo' : '{ exhibitor } schäden',
    'DAMAGE.Status_Label_New' : 'Ungeprüft',
    'DAMAGE.Status_Label_Check' : '1. Prüfung',
    'DAMAGE.Status_Label_DCheck' : 'Finale Prüfung',
    'DAMAGE.Button_Text_Stand' : 'Stand',
    'DAMAGE.Button_Text_Photo' : 'Foto',
    'DAMAGE.Button_Text_AddNote' : "NOTIZ HINZUFÜGEN",
    'DAMAGE.Modal_Button_AddPhoto' : 'Foto hinzufügen',
    'DAMAGE.Modal_Button_CreateReport' : 'Schaden anlegen',
    'DAMAGE.Modal_Button_EditReport' : 'Schaden bearbeiten',
    'DAMAGE.AsCraft_label' : "Schaden",
    "DAMAGE.Button_Text_Open" : "Öffnen",
    "STAND.Block_Title_Damages" : "Schaden",
    'MENUS.Label_Overview' : 'Übersicht',
    'MENUS.Label_Stands' : 'Stände',
    'MENUS.Label_Jobs' : 'Jobs',
    'MENUS.Label_ExpoPlan' : 'Hallenplan',
    'MENUS.Label_More' : 'Mehr',
    'MENUS.Label_SelectExhibition' : 'Veranstaltung auswählen',
    'MENUS.Label_CraftsOverview' : 'Gewerkeübersicht',
    'MENUS.Label_HallsOverview' : 'Hallenübersicht',
    'MENUS.Label_ViewDamages' : 'Schäden anzeigen',
    'MENUS.Label_Downloads' : 'Downloads',
    'MENUS.Label_Documents' : 'Dokumente',
    'MENUS.Label_FurnishingLeftovers' : 'LM Ausstattung',
    'MENUS.Label_HelpImprint' : 'Impressum',
    'MENUS.Label_CollectGraphics' : 'Grafik einlagern',
    'NO_DATA.Exhibitions' : 'Dir wurden noch keine Veranstaltungen zugewiesen.',
    'NO_DATA.Documents' : 'Aktuelle Ausstellung hat noch keine { br } Dokumente.',
    'NO_DATA.Stands' : 'Es wurden keine Stände gefunden,  { br } die der Anforderung entsprechen.',
    'NO_DATA.StandPhoto' : 'Du hast noch kein Standfoto.',
    'NO_DATA.DamagePhoto' : 'Sie haben noch kein Foto der Schäden { br } an diesem Stand',
    'NO_DATA.Stand_NoKeys' : 'Dieser Stand hat noch keine Schlüssel.',
    'NO_DATA.Stand_DoesNotExist' : 'Dieser Stand existiert nicht.',
    'NO_DATA.Subcontractor_Unsigned' : 'Nicht zugewiesen',
    'NO_DATA.Jobs' : 'Es wurden keine Jobs gefunden,  { br } die der Anforderung entsprechen.',
    'NO_DATA.Damages' : 'Es wurden keine Schäden gefunden,  { br } die der Anforderung entsprechen.',
    'NO_DATA.Hall' : 'Diese Halle existiert nicht.',
    'NO_DATA.HallPlan' : 'Wir haben keinen Plan von dieser Halle gefunden.',
    'NO_DATA.Furnishing_Storage' : 'Diese Ausstellung hat { br } keine Möbel im Lager',
    'NO_DATA.Furnishing_Orders' : 'Diese Ausstellung hat { br } keine Einrichtungsaufträge',
    'PAGE.Title_Overview' : 'Übersicht',
    'PAGE.Title_ExhibitionSelection' : 'Veranstaltungswahl',
    'PAGE.Title_Stands' : 'Stände',
    'PAGE.Title_Stand' : 'Stand',
    'PAGE.Title_StandComments' : 'Standkommentare',
    'PAGE.Title_StandLog' : 'Stand Log',
    'PAGE.Title_StandKeys' : 'Standschlüssel',
    'PAGE.Title_ViewDamages' : 'Schäden anzeigen',
    'PAGE.Title_AdditionalMenu' : 'Zusätzliches Menü',
    'PAGE.Title_Jobs' : 'Jobs',
    'PAGE.Title_ExpoPlan' : 'Hallenplan',
    'PAGE.Title_Documents' : 'Dokumente',
    'PAGE.Title_FurnishingLeftovers' : 'LM Artikelübersicht',
    'PAGE.Title_FurnishingReturns' : 'Änderungs- Log',
    'PAGE.Title_HallPlan' : 'Hallenplan',
    'PAGE.Title_HallsOverview' : 'Hallenübersicht',
    'PAGE.Title_CraftsOverview' : 'Gewerkeübersicht',
    'PAGE.Title_HelpImprint' : 'Impressum',
    'PAGE.Title_CollectGraphics' : 'Grafik Einlagern',
    'SORT.Text_NewestByCreation' : 'Neuestes nach Erstellungsdatum',
    'SORT.Text_OldestByCreation' : 'Ältestes nach Erstellungsdatum',
    'SORT.Text_ExhibitorNameAZ' : 'Aussteller (A-Z)',
    'SORT.Text_ExhibitorNameZA' : 'Aussteller (Z-A)',
    'SORT.Text_FinishedFirst' : 'Zuerst fertiggestellt',
    'SORT.Text_InProgressFirst' : 'Zuerst offen',
    'SORT.Text_StandNumberAZ' : 'Stand nummer (A-Z)',
    'SORT.Text_StandNumberZA' : 'Stand nummer (Z-A)',
    'SORT.Text_CorridorAZ' : 'Gang (A-Z)',
    'SORT.Text_CorridorZA' : 'Gang (Z-A)',
    'SORT.Text_BlockAZ' : 'Block (A-Z)',
    'SORT.Text_BlockZA' : 'Block (Z-A)',
    'SORT.Text_FlagFirst' : 'Zuerst mit Flagge',
    'SORT.Text_FlagLast' : 'Mit Flagge zuletzt',
    'SORT.Text_HallAZ' : 'Halle (A-Z)',
    'SORT.Text_HallZA' : 'Halle (Z-A)',
    'SORT.Text_StatusAZ' : 'Genehmigt',
    'SORT.Text_StatusZA' : 'Ungeprüft',
    'STAND.Modal_Title_Search' : 'Suche',
    'STAND.Input_Placeholder_Search' : 'Suche',
    'STAND.Filter_Params_Exhibitor' : 'Aussteller: { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'Mit Kommentaren',
    'STAND.Card_Hero_Hall' : 'Halle',
    'STAND.Card_Hero_Block' : 'Block',
    'STAND.Card_Hero_Stand' : 'Stand',
    'STAND.Card_Hero_DeliveryTime' : 'Deadline',
    'STAND.Modal_Title_StandPlan' : 'Standzeichnung',
    'STAND.Modal_Button_StandPlan' : 'Zeichnung',
    'STAND.Card_Button_Details' : 'Details { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Standfoto',
    'STAND.Modal_Button_StandPhoto' : 'Foto',
    'STAND.Modal_Button_SavePhoto' : 'Foto speichern',
    'STAND.Modal_Button_AddPhoto' : 'Foto hinzufügen',
    'STAND.Button_Text_Comments' : 'Kommentare',
    'STAND.Button_Text_AddComment' : 'Kommentar hinzufügen',
    'STAND.Modal_Title_AddComment' : 'Kommentar hinzufügen',
    'STAND.Modal_Title_EditComment' : 'Kommentar bearbeiten',
    'STAND.Modal_Button_AddComment' : 'Hinzufügen',
    'STAND.Modal_Button_SaveComment' : 'Speichern',
    'STAND.Text_NoComments' : 'Es gibt noch keine Kommentare',
    'STAND.Text_AddFile' : 'Datei hinzufügen',
    'COMMENTS.Text_Uploading' : 'Wird hochgeladen...',
    'STAND.Text_EditComment' : 'Bearbeiten',
    'STAND.Text_DeleteComment' : 'Löschen',
    'STAND.Text_CommentDraftError' : 'Entwurfskommentar ist noch nicht bereit',
    'STAND.Block_Title_Overview' : 'Übersicht',
    'STAND.Block_Title_Materials' : 'Zusätzliche Informationen',
    'STAND.Block_Title_Crafts' : 'Gewerke',
    'STAND.Block_ItemTitle_Hall' : 'Halle',
    'STAND.Block_ItemTitle_Block' : 'Block',
    'STAND.Block_ItemTitle_Stand' : 'Stand',
    'STAND.Block_ItemTitle_ProaufNumber' : 'PROAUF Nummer',
    'STAND.Block_ItemTitle_Jobs' : 'Jobs',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } in Bearbeitung',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } offen',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } Fertig',
    'STAND.Block_Button_ViewStandJobs' : 'Jobs Anzeigen',
    'STAND.Modal_Title_StandGraphic' : 'Standgrafik',
    'STAND.Modal_Button_StandGraphic' : 'Standgrafik',
    'STAND.Modal_Title_ExtraInfo' : 'Zusatzinfo',
    'STAND.Modal_Button_ExtraInfo' : 'Zusatzinfo',
    'STAND.Button_Text_ViewKeys' : 'Schlüssel',
    'STAND.Button_Text_ViewLogs' : 'Logs anzeigen',
    'STAND.Modal_Button_AddKey' : 'Schlüssel hinzufügen',
    'STAND.Modal_Title_AddKey' : 'Schlüssel hinzufügen',
    'STAND.Modal_Title_EditKey' : 'Schlüssel bearbeiten',
    'STAND.Modal_Button_UpdateKey' : 'Schlüssel aktualisieren',
    'STAND.Filter_Params_Stand' : 'Stand { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Löschen',
    'STAND.Text_ModalDelete_Question' : 'Schlüssel { keyName } wirklich löschen?',
    'STAND.External_Exhibition' : 'Ausstellung, der Sie nicht zugewiesen sind',
    'JOB.Button_Text_ViewPhoto' : 'Foto ansehen',
    'OVERVIEW_TYPES.Label_InTotal' : 'gesamt',
    'OVERVIEW_TYPES.Label_Finished' : 'fertig',
    'OVERVIEW_TYPES.Label_Open' : 'offen',
    'OVERVIEW_TYPES.Label_Claims'  : 'reklamiert',
    'OVERVIEW_TYPES.Label_LastMinute' : 'last min',
    'OVERVIEW_TYPES.Label_Overdue' : 'überfällig',
    'FURNISHING.TabName_Storage'   : 'LM Artikel',
    'FURNISHING.TabName_Refund'    : 'Möbel Returen',
    'FURNISHING.TabName_OrderLog'  : 'Änderungs- Log',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'LM Ausstattungsmengen',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Verfügbare Ausstattung',
    'FURNISHING.Button_Text_Return' : 'Zurückkehren',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Ausstattung auswählen',
    'FURNISHING.Modal_Title_Photo' : "Foto von Möbeln",
    'FURNISHING.Order_Type_Refund' : "Zurückkehren",
    'FURNISHING.Order_Type_Lost'   : "Verloren",
    'FURNISHING.Order_Type_Correction' : "Korrektur",
    'FURNISHING.Order_Type_Order'  : "Befehl",
};

export default deutsch;
